<template>
  <div class="address-item">
    <div class="address-item-cnt">
      <van-cell
        required
        :title="title"
        :value="value"
        is-link
        @click="showPopup"
        :label="isRequired ? '请选择' + title : ''"
      />
      <van-popup
        closeable
        v-model:show="show"
        position="bottom"
        :style="{ height: '30%' }"
        @close="close"
      >
        <div class="select-item-cnt-cell">
          <van-cell
            v-for="{ value, key } in list"
            :key="value"
            :title="value"
            @click="select(key, value)"
          >
          </van-cell>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from "vue";
export default {
  name: "Select",
  props: {
    title: {
      type: String,
    },
    value: {
      type: String,
      default: "请选择",
    },
    list: {
      type: Object,
    },
    handlerSelect: {
      type: Function,
    },
    isClick: {
      type: Boolean,
      default: true,
    },
    isRequired: {
      type: Boolean,
    },
  },

  setup(props) {
    const state = reactive({
      title: "",
      value: "",
      show: false,
      list: [],
      isClick: "",
    });
    onMounted(() => {
      const { isClick = true, list, value, title } = props;
      state.list = list;
      state.isClick = isClick;
      state.value = value;
      state.title = title;
    });

    const showPopup = () => {
      if (props.isClick) {
        state.show = true;
      }
    };
    const close = () => {
      state.show = false;
    };

    const select = (key, value) => {
      const { handlerSelect } = props;
      close();
      handlerSelect(key, value);
    };
    return {
      ...toRefs(state),
      showPopup,
      close,
      select,
    };
  },
};
</script>

<style lang="less" scoped>
:deep(.van-cell__label) {
  color: #ee0a24;
}
// .address-item {
//   padding: 0.133rem 0;
//   &-cnt {
//     font-size: 0.48rem;
//     height: 1.067rem;
//     line-height: 1.067rem;
//     padding: 0 0.4rem;
//     margin: 0 0.133rem;
//     background: #fff;
//     box-shadow: 0 0 0.267rem #e9f0ff;
//     border-radius: 0.107rem;
//   }
// }
// .select_box {
//   margin-right: 15px;
// }
// :deep(.van-cell) {
//   padding: 0;
//   height: 1.067rem;
//   line-height: 1.067rem;
//   align-items: center;
//   font-size: 0.48rem;
// }
// :deep(.van-cell__title) {
//   font-size: 0.48rem;
// }
// :deep(.van-cell__value) {
//   font-size: 0.347rem;
// }
// :deep(.select-item-cnt-cell) .van-cell__title span {
//   padding-left: 20px;
// }
// .select-item-cnt-cell {
//   padding: 10px;
// }
</style>
